<div class="app-container">
  <!-- One header bar for the whole app: the page's name, then the controls. -->
  <header class="app-header">
    <div class="app-header-start">
      <app-nav-menu />
      <h1 class="app-title">{{ pageTitle() }}</h1>
    </div>
    <app-user-menu />
  </header>
  <div class="app-content">
    <router-outlet />
  </div>
  <app-footer></app-footer>
</div>
<p-toast position="top-right"></p-toast>
